"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _now = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/date/now"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _LogService = require("../../../../KESI2/Services/LogService");

var _ResumeSuspendListeners = require("../../../../helpers/ResumeSuspendListeners");

var _TimeoutHelper = require("../../../../helpers/TimeoutHelper");

var ListenedSequences = /*#__PURE__*/function () {
  /**
   *
   * @param podcastNugget {PodcastNugget}
   * @param audioElement {HtmlElement}
   */
  function ListenedSequences(podcastNugget, audioElement) {
    var _this = this;

    (0, _classCallCheck2["default"])(this, ListenedSequences);
    (0, _defineProperty2["default"])(this, "postLogMessage", function () {
      _this._addCurrentSequence();

      if (_this.listenedSequences.sequences.length > 0) {
        (0, _LogService.pushAudioUsageLogMessage)(_this.podcastNugget.id, null, _this.listenedSequences.sequences);
      }

      return _this._reset();
    });
    (0, _defineProperty2["default"])(this, "onPlay", function () {
      if (_this.player.currentTime) {
        _this.latestStart = _this.player.currentTime;
      }

      _this.currentTrack = _this.player.src;
    });
    (0, _defineProperty2["default"])(this, "onPause", function () {
      _this._addCurrentSequence();
    });
    (0, _defineProperty2["default"])(this, "onSeeked", function () {
      _this._addCurrentSequence();

      _this.latestStart = _this.player.currentTime;
    });
    (0, _defineProperty2["default"])(this, "onSeeking", function () {
      _this._addCurrentSequence();

      _this.latestStart = _this.player.currentTime;
    });
    (0, _defineProperty2["default"])(this, "onTimeupdate", function () {
      /*
       * Some devices send neither seeking nor seeked events (e.g. iPad iOS 7).
       * They also don't set the seeking property.
       * So we calculate if the timing suggests that the user seeked.
       * This method fails if the users drags at roughly the same speed as the
       * video would play but it's the best we can do without the necessary events.
       */
      var actualTimeDelta;
      var playerDelta;
      playerDelta = _this.player.currentTime - _this.latestPosition;
      actualTimeDelta = (0, _now["default"])() - _this.lastTimeupdateEvent;
      actualTimeDelta /= 1000;
      _this.lastTimeupdateEvent = (0, _now["default"])();

      if (Math.abs(playerDelta - actualTimeDelta) > 1) {
        _this._addCurrentSequence();

        _this.latestStart = _this.player.currentTime;
      }

      _this.latestPosition = _this.player.currentTime;
    });
    this.podcastNugget = podcastNugget;
    this.player = audioElement;
    this.lastTimeupdateEvent = null;
    this.listenedSequences = {
      sequences: []
    };
    this.latestStart = 0;
    this.latestPosition = 0;
    this.currentTrack = null;
    this.lastTimeupdateEvent = (0, _now["default"])();
    this.initForPlayer();
  }

  (0, _createClass2["default"])(ListenedSequences, [{
    key: "postAndUnload",
    value: function postAndUnload() {
      this.postLogMessage();
      (0, _ResumeSuspendListeners.removeOnSuspendListener)(this.postLogMessage);
      this.player.removeEventListener('timeupdate', this.onTimeupdate);
      this.player.removeEventListener('seeking', this.onSeeking);
      this.player.removeEventListener('seeked', this.onSeeked);
      this.player.addEventListener('pause', this.onPause);
      this.player.addEventListener('play', this.onPlay);
    }
  }, {
    key: "_addCurrentSequence",
    value: function _addCurrentSequence() {
      var _this2 = this;

      var drupalEl = this.podcastNugget.audios.find(function (audio) {
        return audio.audioFile === _this2.currentTrack;
      });

      if (drupalEl && this.currentTrack) {
        var drupalId = drupalEl.id;

        if (this.latestPosition > this.latestStart + 1) {
          this.listenedSequences.sequences.push({
            start: this.latestStart,
            end: this.latestPosition,
            trackId: drupalId
          });
        }
      }

      this.latestStart = 0;
      this.latestPosition = 0;
    }
  }, {
    key: "_reset",
    value: function _reset() {
      this.listenedSequences = {
        sequences: []
      };
      this.latestStart = 0;
      this.latestPosition = 0;
      this.currentTrack = null;
    }
  }, {
    key: "initForPlayer",
    value: function initForPlayer() {
      (0, _ResumeSuspendListeners.addOnSuspendListener)(this.postLogMessage);
      this.player.addEventListener('timeupdate', this.onTimeupdate);
      this.player.addEventListener('seeking', this.onSeeking);
      this.player.addEventListener('seeked', this.onSeeked);
      this.player.addEventListener('pause', this.onPause);
      this.player.addEventListener('play', this.onPlay);
    }
  }]);
  return ListenedSequences;
}();

var _default = ListenedSequences;
exports["default"] = _default;